import { useTranslation } from "react-i18next";

import { RecoveryActionModal } from "./RecoveryActionModal";

type ClientConfigFailedDialogProps = {
  open: boolean;
  onRetry: () => void;
  onGoToLogout: () => void;
};

export const ClientConfigFailedDialog = ({
  open,
  onRetry,
  onGoToLogout
}: ClientConfigFailedDialogProps) => {
  const { t } = useTranslation();

  return (
    <RecoveryActionModal
      isOpen={open}
      labelledById="client-config-failed-dialog-title"
      title={t("client config fetch failed")}
      message={t("unable to fetch client configuration message")}
      primaryAction={{ label: t("try again"), onClick: onRetry }}
      secondaryAction={{ label: t("go to logout"), onClick: onGoToLogout }}
    />
  );
};
